'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
export function HorizontalSlider(t0) {
  const $ = _c(9);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef] = useEmblaCarousel(t1);
  let t2;
  if ($[1] !== className) {
    t2 = cn("overflow-hidden", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <div className="flex gap-12">{children}</div>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== emblaRef || $[6] !== t2 || $[7] !== t3) {
    t4 = <div ref={emblaRef} className={t2}>{t3}</div>;
    $[5] = emblaRef;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}